



















import { Component, Vue, Prop, PropSync } from 'vue-property-decorator';
import IssueRow from '@/components/Issues/IssueRow.vue';
import env from '@/env';
import axios from 'axios';
import draggable from 'vuedraggable';
import { Cutoverplan } from '@/interfaces/Cutoverplan';

@Component({
  components: { IssueRow, draggable }
})
export default class EditCutoverplanIssuesTab extends Vue {
  @Prop()
  cutoverplan?: Cutoverplan;

  @Prop()
  issues?: any;

  @PropSync('issues')
  issuesSync?: any;

  dragOptions = {
    animation: 0,
    group: 'description',
    disabled: false,
    ghostClass: 'ghost'
  };

  async addIssue() {
    const { data: issue } = await axios.post(`${env.backend_url}/issue`, {
      cutoverplan_id: this.cutoverplan?.id,
      subject: '',
      description: ''
    });
    this.issues.push(issue);
  }
}
